import React, {useState, useRef} from 'react';
import {Modal} from "../../../utils/modal/Modal";
import {formatErrors, coursePeriods, smiles} from "../../../constants";
import {useDispatch} from "react-redux";
import {toast} from "react-toastify";
import {i_attach, i_smile} from "../../../icons";
import {mailingEditAction} from "../../../actions/mailingAction";
import cfg from "../../../constants";

export function MailingEditModal({item, user, usersNames, trigger, onSuccess}) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const inputRef = useRef();
  const dispatch = useDispatch();

  const handleOpen = (value) => {
    if (loading) {
      return;
    }
    setOpen(value);
  };

  const handleSmile = (e) => {
    if (inputRef.current.value.length + e.target.value.length > 4096) {
      return;
    }
    const current = inputRef.current.value;
    inputRef.current.value = current.substring(0, inputRef.current.selectionStart) +
      e.target.value +
      current.substring(inputRef.current.selectionStart, current.length);
  };

  const handleSubmit = () => {
    if (loading) {
      return false;
    }
    const values = {
      id: item.id,
      message_text: inputRef.current.value.trim()
    };
    if (!values.message_text && !item.file) {
      return;
    }
    setLoading(true);

    dispatch(mailingEditAction(values)).then(() => {
      setLoading(false);
      setOpen(false);
      onSuccess();
    }).catch((e) => {
      setLoading(false);
      toast.error(formatErrors([e.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  };

  return <Modal isStatic={true} open={open} handleOpen={handleOpen} trigger={trigger} triggerWrap={false}>
    <React.Fragment>
      <div className="modal__title">Массовая рассылка</div>

      <p className="modal__subtitle modal__subtitle--left">Пользователи:
        {item.client_ids.length > 0 && <span> выбраны {item.client_ids.split(',').length}</span>}
        {item.client_ids.length === 0 && (!item.curator_id || item.curator_id === user.id) && <span> Все</span>}
        {item.client_ids.length === 0 && item.curator_id && item.curator_id !== user.id && <span> Все пользователи куратора {usersNames[item.curator_id]}</span>}
      </p>

      <p className="modal__subtitle modal__subtitle--left">
        Ступень программы:
        <span> {item.program_stages ? item.program_stages.split(',').map((pi) => coursePeriods[pi].title).join(', ') : 'Любая'}</span>
      </p>
      <div className="chat-panel__inner">
        <textarea ref={inputRef} className="chat-panel__text" defaultValue={item.message_text} placeholder="Написать..." disabled={loading} maxLength={4096}></textarea>
        <button type="button" className="chat-panel__icon">
          {i_smile()}
          <ul className="dropdown dropdown--top dropdown--flex">
            {smiles.map((i, k) => <li key={k} className="dropdown__item">
              <input type="button" value={i} className="dropdown__smile" onClick={handleSmile} />
            </li>)}
          </ul>
        </button>
      </div>
      {item.file !== '' && <div className="chat-panel__attached">
        <div className="attached--item"><span className="attached--icon">{i_attach()}</span> <a href={cfg.public_url + 'auth/file/' + item.user_id + '/i/' + item.file} target="_blank" rel="noreferrer">{item.file}</a></div>
      </div>}
      <button type="button" className="modal__btn btn" onClick={handleSubmit} disabled={loading}>Сохранить</button>
    </React.Fragment>
  </Modal>
};
